<i18n src="./resources/locales.json"></i18n>

<template>
  <v-menu :disabled="disabled" top offset-y left transition="slide-y-transition">
    <template v-slot:activator="{ on: menu }">
      <slot :menu="menu">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              :ripple="false"
              :disabled="disabled"
              :x-small="xSmall"
              icon
              :height="height"
              :width="width"
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon>mdi-comment-text</v-icon>
            </v-btn>
          </template>
          <span v-once>{{ $t('tooltips.cannedResponses') }}</span>
        </v-tooltip>
      </slot>
    </template>
    <v-list class="canned-responses-menu">
      <v-list-item
        v-for="(item, index) in cannedResponses"
        :key="index"
        class="canned-response-bubble"
        :ripple="false"
        @click="sendCannedResponse(item)"
      >
        <v-list-item-title>
          <div class="canned-item-title">
            {{ item.name }}
          </div>
          <div v-show="cannedResponsesOpenStates[index]" class="canned-item-text">
            {{ item.text }}
          </div>
          <div class="canned-item-icon">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="canned-item-btn" rounded icon @click.stop="openResponsePreview(index)" v-on="on">
                  <v-icon small>
                    {{ cannedResponsesOpenStates[index] ? 'mdi-menu-up' : 'mdi-menu-down' }}
                  </v-icon>
                </v-btn>
              </template>
              <span v-once>
                {{ $t('buttons.previewCannedResponse') }}
              </span>
            </v-tooltip>
          </div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { EMAIL_MEDIA_TYPE, CHAT_MEDIA_TYPE, SMS_MEDIA_TYPE } from '@/constants/mediaTypes';
import ReferenceDataService from '@/services/referenceDataService';

export default {
  name: 'CannedResponses',

  props: {
    elementId: {
      type: String,
      required: true
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 40
    },
    width: {
      type: Number,
      default: 40
    }
  },

  data() {
    return {
      cannedResponses: [],
      cannedResponsesOpenStates: []
    };
  },

  computed: {
    ...mapGetters('INTERACTIONS', ['getInteraction']),

    ...mapGetters('ELEMENTS', ['getElement']),

    element() {
      return this.getElement(this.elementId);
    },

    interaction() {
      return this.getInteraction(this.element.interactionId);
    },

    disabled() {
      return this.element.isClosed || this.element.isAbandoned || this.element.isOnHold;
    }
  },

  created() {
    this.getCannedResponses();
  },

  methods: {
    sendCannedResponse(message) {
      this.$emit('canned-response', message, this.elementId);
    },

    getCannedResponses() {
      const mediaTypeFallback = this.interaction.isSms ? SMS_MEDIA_TYPE : EMAIL_MEDIA_TYPE;
      // NOTE: Chat or e-mail media types are specific to the cannedResponsesRepository in the configuration data
      const mediaType = this.interaction.isChat ? CHAT_MEDIA_TYPE : mediaTypeFallback;

      ReferenceDataService.getCannedResponses(this.interaction.routing.businessProcessId, mediaType).then(response => {
        this.cannedResponses = response.data;
        this.cannedResponses.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      });
    },

    openResponsePreview(index) {
      this.cannedResponsesOpenStates[index] = !this.cannedResponsesOpenStates[index];
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.canned-item-title {
  width: calc(100% - 16px);
  font-weight: bold;
  font-size: 13px;
}

.canned-item-text {
  width: calc(100% - 16px);
  padding: 4px 0;
  opacity: 0.8;
}

.canned-item-icon {
  font-size: 24px !important;
}

.canned-item-icon {
  position: absolute;
  top: 4px;
  right: 4px;
}

.canned-responses-button {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transition: all 0.3s ease;
}

.canned-responses-menu {
  width: 280px;
  max-height: 400px;
  overflow-y: scroll;
  padding: 0;
}

.canned-response-bubble + .canned-response-bubble {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.canned-response-bubble .v-list-item__title {
  font-size: 12px;
  line-height: 14px;
  white-space: normal;
  padding: 12px 8px;
}

.v-menu__content {
  z-index: 500 !important;
}
</style>
